import styled from 'styled-components'

import { helpers } from 'styles'

export const Header = styled.h3`
	font-size: ${helpers.font.size.caption};
	text-align: left;
	color: ${helpers.color.listHeader};
	padding: 0 16px;
`
